import { render, staticRenderFns } from "./BuyWindow.vue?vue&type=template&id=3bb709fc&scoped=true&"
import script from "./BuyWindow.vue?vue&type=script&lang=js&"
export * from "./BuyWindow.vue?vue&type=script&lang=js&"
import style0 from "./BuyWindow.vue?vue&type=style&index=0&id=3bb709fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb709fc",
  null
  
)

export default component.exports